<div class="thumbnail-controls">
  <p-selectbutton
    optionLabel="label"
    optionValue="value"
    [options]="thumbnailOptions"
    [unselectable]="true"
    [allowEmpty]="false"
    [(ngModel)]="thumbnailSize"
    (onChange)="setSize($event.value)"
  >
    <ng-template
      let-option
      pTemplate="item"
    >
      <i [class]="option.icon"></i>
      <span class="sr-only">{{ option.label | translate }}</span>
    </ng-template>
  </p-selectbutton>
</div>

<div
  #thumbnailGrid
  class="thumbnail-grid"
  cdkDropList
  cdkDropListOrientation="mixed"
  role="listbox"
  [ngClass]="thumbnailSize + '-grid'"
  [attr.aria-label]="'documentSplit.documentThumbnails' | translate"
  [attr.aria-multiselectable]="mode === 'split'"
  (cdkDropListDropped)="drop($event)"
>
  @if (isLoading) {
    @for (item of Array(10); track $index) {
      <p-skeleton
        width="100%"
        height="275px"
      />
    }
  } @else {
    @for (thumb of thumbnails; track $index) {
      <button
        cdkDrag
        cdkDragBoundary=".thumbnail-grid"
        type="button"
        role="option"
        class="dap-thumbnail thumbnail"
        [tabindex]="getTabIndex($index)"
        [ngClass]="thumbnailSize"
        [attr.aria-selected]="isSelected($index)"
        [class.selected]="isSelected($index)"
        (click)="onClickPage($index)"
        (keydown)="onKeyDown($event, $index)"
      >
        <img
          [src]="thumb"
          [alt]="fileName + ' - ' + ('documentSplit.pageNumber' | translate) + ($index + 1)"
        />
        <div class="thumbnail-footer">
          @if (isSelected($index)) {
            <span class="selected-checkbox"><i class="fa-solid fa-circle-check"></i></span>
          }
          <span
            class="page-number"
            aria-hidden="true"
          >
            {{ 'documentSplit.page' | translate }} {{ $index + 1 }}</span
          >
        </div>
        <div
          aria-live="polite"
          class="sr-only"
        >
          {{ screenReaderMessage }}
        </div>
      </button>
    }
  }
</div>
